import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminService {
  private apiUrl = `${environment.apiBaseUrl}/adminR`;

  constructor(private http: HttpClient) { }

  getUsers(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null
      }
    };
    console.log("in getusers in service")
    console.log(`${this.apiUrl}/users`);
    return this.http.post(`${this.apiUrl}/users`, body, { headers });
  }

  addUser(user: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null,
        "username": user.username,
        "loginId": user.loginId,
        "password": user.password,
        "userType": user.userType,
        "userStatus": user.userStatus,
        "userBatch": user.userBatch
      }
    };
    return this.http.post(`${this.apiUrl}/addUser`, body, { headers });
  }

  updateUser(user: any): Observable<any> {
    console.log(user);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null,
        "username": user.username,
        "loginId": user.loginId,
        "password": user.password,
        "userType": user.userType,
        "userStatus": user.userStatus,
        "userBatch": user.userBatch
      }
    };
    return this.http.post(`${this.apiUrl}/updateUser`, body, { headers });
  }
  getBatches(): Observable<any> {
    console.log("Getting batches");
    console.log(`${this.apiUrl}/allBatches`);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null
      }
    };
    return this.http.post(`${this.apiUrl}/allBatches`, body, { headers });
  }
  resetPassword(userId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "userId": userId,
        "tenant": null
      }
    };
    return this.http.post(`${this.apiUrl}/reset-password`, body, { headers });

    //    return this.http.post(`${this.apiUrl}/users/${userId}/reset-password`, {});
  }

  getDBDump(dbName: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "dbName": dbName,
        "tenant": null
      }
    };
    return this.http.post(`${environment.apiBaseUrl}/reportR/getDatabaseDump`, body, { headers });
  }

  getDumpList(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null
      }
    };
    return this.http.post(`${environment.apiBaseUrl}/reportR/getDumpPath`, body, { headers });
  }

  downloadDump(filePath: string): Observable<Blob> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authfor': 'W'
    });
    const body = {
      'criteria': {
        'filePath': filePath
      }
    };
    return this.http.post(`${environment.apiBaseUrl}/reportR/downloadExcelZip`, body, {
      headers,
      responseType: 'blob'
    });
  }

}
